import { useMutation } from '@apollo/client';
import { CREATE_ASSET } from '../gql/mutations';
import { v4 as uuidv4 } from 'uuid';

export const useCreateProxyAsset = () => {
    const [ createAsset ] = useMutation( CREATE_ASSET );
    
    const createProxyAsset = async ( { proxyObjectId } ) => {
        const uuid = uuidv4();

        try {
            const variables = {
                'input': {
                    id: uuid,
                    type: 'PROXY',
                    name: proxyObjectId,
                    lxpProxyObjectId: proxyObjectId 
                }

            };
            
            const response = await createAsset( { variables } );
            const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
            
            if ( success && response?.data?.result?.id ) {
                return uuid;
            } else {
                console.error( 'Error at createProxyAsset' );
                return { error: true };
            } 
        } catch ( error ) { 
            console.error( 'Error at createProxyAsset', error );
            return { error: true };
        }     
    };

    return {
        createProxyAsset
    };
};
